import React, { useEffect, useRef } from 'react'
import Talk from 'talkjs'

import SingleChatView from '../component/SingleChatView'
import { CONFIG } from '../../../../Config/config'

const { appID } = CONFIG.TALKJS

const MissionChat = ({ userId, conversationId, isCityManager = true }) => {
  let ref = useRef(null)

  const initChat = async ({ conversationId, ref, userId }) => {
    await Talk.ready

    const me = new Talk.User(userId)

    const session = new Talk.Session({
      appId: appID,
      me,
    })

    const conversation = session.getOrCreateConversation(conversationId)
    const chatbox = session.createChatbox({
      theme: 'admin_cm_theme',
      captureKeyboardEvents: true,
      showChatHeader: isCityManager,
    })

    chatbox.select(conversation)

    chatbox.onKeydown(e => {
      e.preventDefault()
    })
    chatbox.mount(ref)
  }

  useEffect(() => {
    if (userId) {
      initChat({
        conversationId,
        ref,
        userId,
      })
    }
  }, [conversationId, userId])

  const setRef = value => {
    ref = value
  }

  return <SingleChatView onlyRead={true} setRef={setRef} />
}

export default MissionChat
